/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AddPerson from './add-person-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AddPerson {...validProps} />;
}
SvgComponent.iconName = 'addPerson';

export const AddPersonIcon = svgIconWrapper(SvgComponent);
